import IMemberUserRepository from "../../../domain/interfaces/repositories/IMemberUserRepository";
import {ChangePasswordMethodMemberUserCommandRequest} from "../../../domain/entities/memberUser";

export const ResetPassLoggedUserCommand = (
	repository: IMemberUserRepository,
	data: ChangePasswordMethodMemberUserCommandRequest
) => {
	return repository.reset(data)
}
